const info = {
    title: `Get Travel Medication`,
    subtitle: `Take The Medication You Need`,
}

export default info

